import { render, staticRenderFns } from "./mediaLinks.vue?vue&type=template&id=21dd201c&scoped=true"
import script from "./mediaLinks.vue?vue&type=script&lang=js"
export * from "./mediaLinks.vue?vue&type=script&lang=js"
import style0 from "./mediaLinks.vue?vue&type=style&index=0&id=21dd201c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd201c",
  null
  
)

export default component.exports